import { useState, useEffect, useContext } from "react";
import { loginUser } from "../api/authService";
import { jwtDecode } from "jwt-decode";
import { useAuthState } from "../providers/AuthStateProvider"; // Access auth state
import { useNavigate, useParams } from "react-router-dom"; // For navigating after login
import { comfirmBooking } from "../api/bookingApi";
import { BarbershopContext } from "../providers/useProvider";

const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { login, user } = useAuthState(); // Get login function from context
  const navigate = useNavigate();
  const { barbershopName } = useParams();
  const { shopClosedDays, shopClosedWeekDays, config } =
    useContext(BarbershopContext);

  useEffect(() => {
    const pending = JSON.parse(sessionStorage.getItem("pendingBooking"));

    if (user.token && pending) {
      const confirmAndNavigate = async () => {
        try {
          const response = await comfirmBooking(pending, config.id); // assuming this returns the booking ID

          if (!response) return;
          sessionStorage.removeItem("pendingBooking");
          localStorage.removeItem("intendedRoute");
          navigate(`/${response.data}/appointment-summary`);
        } catch (error) {
          console.error("Booking confirmation failed:", error);
        }
      };

      confirmAndNavigate();
    }
  }, [user.token]);

  const handleLogin = async ({ email, password }) => {
    setLoading(true);
    setError(null);

    try {
      const response = await loginUser(
        {
          Email: email,
          Password: password,
        },
        config.barbershopName
      );
      if (response.isSuccess) {
        // Pass the token to AuthStateProvider to store it
        login(response.value.token);
        // Redirect to home page after successful login
        navigate(`/`);
      } else {
        setError(response.errors[0]);
      }

      // assuming response contains the user or token
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Login failed");
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  const handleForgetPassword = (email) => {};
  return {
    loading,
    error,
    handleLogin,
    config,
  };
};

export default useLogin;
